import { render, staticRenderFns } from "./priceAndOrderInfoList.vue?vue&type=template&id=76e5c53a&scoped=true&lang=html&"
import script from "./priceAndOrderInfoList.vue?vue&type=script&lang=js&"
export * from "./priceAndOrderInfoList.vue?vue&type=script&lang=js&"
import style0 from "./priceAndOrderInfoList.vue?vue&type=style&index=0&id=76e5c53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e5c53a",
  null
  
)

export default component.exports